import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { STATIC_MODAL_DATA } from "../../../../Data/UiKit/Modal";
import { BohoLogin, StaticBackdropModalBtn, StaticBackdropModals } from "../../../../Constant";
import { Btn, H3, P } from "../../../../AbstractElements";
import CommonModal from "../Common/CommonModal";
import { useState } from "react";
import { StaticForm } from "./StaticForm";

const StaticBackdropModal = () => {
  const [staticModal, setStaticModal] = useState(false);
  const staticModalToggle = () => setStaticModal(!staticModal);
  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={StaticBackdropModals} span={STATIC_MODAL_DATA} />
        <CardBody>
          <Btn color="primary" type="button" onClick={staticModalToggle}>
            {StaticBackdropModalBtn}
          </Btn>
          <CommonModal backdrop="static"  modalBodyClassName="social-profile text-start" fade={true} isOpen={staticModal} toggle={staticModalToggle}>
            <div className="modal-toggle-wrapper">
              <H3>{BohoLogin}</H3>
              <P>Fill in your information below to continue.</P>
              <StaticForm staticModalToggle={staticModalToggle} />
            </div>
          </CommonModal>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StaticBackdropModal;
